import { render, staticRenderFns } from "./CallbackView.vue?vue&type=template&id=06ef04a4"
import script from "./CallbackView.vue?vue&type=script&lang=js"
export * from "./CallbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports